import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Bulletin board Management Service
 * !== 게시판 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/bltbrd`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/sysm/bltbrd/bltbrd-mgmt`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0111013q: `${BASE.path}/osci0111013q`, // List of Bulletin board Management             !== 게시판 관리 목록 ==!
    osci0111014s: `${BASE.path}/osci0111014s`, // Register for Bulletin board Management        !== 게시판 관리 등록 ==!
    osci0111015s: `${BASE.path}/osci0111015s`, // Modification for Bulletin board Management    !== 게시판 관리 수정 ==!
    osci0111016q: `${BASE.path}/osci0111016q`, // Bulletin board Type Code Popup                !== 게시판 유형코드 팝업 ==!
    osci0111017q: `${BASE.path}/osci0111017q`, // Bulletin board Popup                !== 게시판 유형코드 팝업 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View a list of Bulletin board  !== 게시판 목록 조회 ==!
    getbltbrdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // View Bulletin board information  !== 게시판 정보 조회 ==!
    getbltbrdInfo: (id: any) => api.get(`${BASE.api}/${id}`),

    // Regist Bulletin board information  !== 게시판 정보 등록 ==!
    registBltbrdInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Modify Bulletin board information  !== 게시판 정보 수정 ==!
    modifyBltbrdInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },

    // View Bulletin board Type Code List information  !== 게시판 유형코드 목록 조회 ==!
    getTypeCodeList: () => api.get(`${BASE.api}/tpCd`),
};

export const SF_BLTBRD_MGMT_SRCH: TFormSchema = {
    id: "form_bltbrdSrch",
    schema: {
        bltbrdKorNm: { type: "text", label: "L_BLTBRD_KOR_NM" },
        bltbrdEngNm: { type: "text", label: "L_BLTBRD_EN_NM" },
        bltbrdTzNm: { type: "text", label: "L_BLTBRD_TZ_NM" },
    },
};

const YnOptArr = [
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
];

const atcmUpldLmtNoOptArr = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
];

// Bulletin board Management Form !== 게시판 관리 폼 ==!
export const SF_BLTBRD_MGMT: TFormSchema = {
    id: "form_bltbrdMgmt",
    schema: {
        bltbrdId: { type: "text", label: "L_BLTBRD_ID" },
        bltbrdKorNm: { required: true, type: "text", label: "L_BLTBRD_KOR_NM", maxLength: 24 },
        bltbrdEngNm: { required: true, type: "text", label: "L_BLTBRD_EN_NM", maxLength: 50 },
        bltbrdTzNm: { required: true, type: "text", label: "L_BLTBRD_TZ_NM", maxLength: 50 },
        btbdrpUseYn: { required: true, type: "radio", label: "L_BTBDRP_USE_YN", options: YnOptArr, defaultValue: "N" },
        btbdcmUseYn: { required: true, type: "radio", label: "L_BTBDCM_USE_YN", options: YnOptArr, defaultValue: "N" },
        btbdrpBtbdcmUseYn: {
            required: true,
            type: "radio",
            label: "L_BTBDRP_BTBDCM_USE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        btbdmsSelcExuseYn: {
            required: true,
            type: "radio",
            label: "L_BTBDMS_SELC_EXUSE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        btbdrpSelcExuseYn: {
            required: true,
            type: "radio",
            label: "L_BTBDRP_SELC_EXUSE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        btbdrpSttsUseYn: {
            required: true,
            type: "radio",
            label: "L_BTBDRP_STTS_USE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        chgYn: { required: true, type: "radio", label: "L_MDFC_PSBL_YN", options: YnOptArr, defaultValue: "N" },
        ppupSettPsblYn: {
            required: true,
            type: "radio",
            label: "L_PPUP_SETT_PSBL_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        relaBltbrdUseYn: {
            required: true,
            type: "radio",
            label: "L_RELA_BLTBRD_USE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        btbdmsTpCdUseYn: {
            required: true,
            type: "radio",
            label: "L_BTBDMS_TP_CD_USE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        secrtBtbdmsUseYn: {
            required: true,
            type: "radio",
            label: "L_SECRT_BTBDMS_USE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        selcCntUseYn: {
            required: true,
            type: "radio",
            label: "L_SELC_CNT_USE_YN",
            options: YnOptArr,
            defaultValue: "N",
        },
        btbdmsTpCd: { type: "code", label: "L_BTBDMS_TP_CD", required: true, area: "cstmCd", maxLength: 5 },
        atcmUseYn: { required: true, type: "radio", label: "L_ATCM_USE_YN", options: YnOptArr, defaultValue: "N" },
        useYn: { required: true, type: "radio", label: "L_USE_YN", options: YnOptArr, defaultValue: "Y" },
        atcmUpldLmtNo: { type: "select", label: "L_ATCM_UPLD_LMT_NO", options: atcmUpldLmtNoOptArr },
        atcmCapcLmtYn: { type: "radio", label: "L_ATCM_CAPC_LMT_YN", options: YnOptArr, defaultValue: "N" },
        atcmLmtCapc: { type: "number", label: "L_ATCM_LMT_CAPC", max: 80000 },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM" },
        lastMdfrId: { type: "text", label: "L_LAST_MDFR_ID" },
        lastMdfyDtm: { type: "datetime", label: "L_LAST_MDFY_DTM" },
    },
};

// Bulletin board Management List Grid !== 게시판 관리 목록 그리드 ==!
export const SG_BLTBRD_MGMT_LIST: TGridSchema = {
    id: "grid_bltbrdMgmt",
    options: { pagination: "out", edit: false, index: true },
    head: [
        // { cells: [{ header: "L_NO", binding: "bltbrdNo", width: 100 }] },
        { cells: [{ header: "L_BLTBRD_EN_NM", binding: "bltbrdEngNm", width: "25%" }] },
        { cells: [{ header: "L_BLTBRD_TZ_NM", binding: "bltbrdTzNm", width: "25%" }] },
        { cells: [{ header: "L_BLTBRD_KOR_NM", binding: "bltbrdKorNm", width: "20%" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: "5%" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
        { show: false, cells: [{ binding: "bltbrdId" }] },
    ],
    body: [
        // { cells: [{ binding: "bltbrdNo", edit: false, align: "left" }] },
        { cells: [{ binding: "bltbrdEngNm", align: "left" }] },
        { cells: [{ binding: "bltbrdTzNm", align: "left" }] },
        { cells: [{ binding: "bltbrdKorNm", align: "left" }] },
        { cells: [{ binding: "useYn" }] },
        { cells: [{ binding: "frstRegstId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

// Bulletin board Management List Grid (PopUp) !== 게시판 관리 목록 그리드 (팝업)==!
export const SG_BLTBRD_MGMT_POP_LIST: TGridSchema = {
    id: "grid_bltbrdMgmt",
    options: { checkbox: true, edit: false, index: true },
    head: [
        { cells: [{ header: "L_BLTBRD_KOR_NM", binding: "bltbrdKorNm", width: "20%" }] },
        { cells: [{ header: "L_BLTBRD_EN_NM", binding: "bltbrdEngNm", width: "25%" }] },
        { cells: [{ header: "L_BLTBRD_TZ_NM", binding: "bltbrdTzNm", width: "25%" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: "5%" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
        { show: false, cells: [{ binding: "bltbrdId" }] },
    ],
    body: [
        { cells: [{ binding: "bltbrdKorNm", align: "left" }] },
        { cells: [{ binding: "bltbrdEngNm", align: "left" }] },
        { cells: [{ binding: "bltbrdTzNm", align: "left" }] },
        { cells: [{ binding: "useYn" }] },
        { cells: [{ binding: "frstRegstId" }] },
        { cells: [{ binding: "frstRgsrDtm" }] },
    ],
};

// Bulletin board Type Code List Grid !== 게시판 유형코드 목록 그리드 ==!
export const SG_BLTBRD_TP_CD_LIST: TGridSchema = {
    id: "grid_bltbrd_tpCd",
    options: { checkbox: true, edit: false, index: true },
    head: [
        { cells: [{ header: "L_BTBDMS_TP_CD", binding: "btbdmsTpCd", width: "17.5%" }] },
        { cells: [{ header: "L_KO_NM", binding: "btbdmsTpCdKoNm", width: "27.5%" }] },
        { cells: [{ header: "L_POST_TP_CD_NM_EN", binding: "btbdmsTpCdEnNm", width: "27.5%" }] },
        { cells: [{ header: "L_POST_TP_CD_NM_TZ", binding: "btbdmsTpCdTzNm", width: "27.5%" }] },
    ],
    body: [
        { cells: [{ binding: "btbdmsTpCd" }] },
        { cells: [{ binding: "btbdmsTpCdKoNm", align: "left" }] },
        { cells: [{ binding: "btbdmsTpCdEnNm", align: "left" }] },
        { cells: [{ binding: "btbdmsTpCdTzNm", align: "left" }] },
    ],
};

// Bulletin board Message Type Code Value List Grid !== 게시글 유형코드 목록 값 그리드 ==!
export const SG_BTBDMS_TP_CD_VAL_LIST: TGridSchema = {
    id: "grid_bltbrd_tpCdVal",
    options: { edit: false, index: true },
    head: [
        { cells: [{ header: "L_KO_NM", binding: "btbdmsTpCdKoNm", width: "33%" }] },
        { cells: [{ header: "L_POST_TP_CD_NM_EN", binding: "btbdmsTpCdEnNm", width: "34%" }] },
        { cells: [{ header: "L_POST_TP_CD_NM_TZ", binding: "btbdmsTpCdTzNm", width: "34%" }] },
    ],
    body: [
        { cells: [{ binding: "btbdmsTpCdKoNm", align: "left" }] },
        { cells: [{ binding: "btbdmsTpCdEnNm", align: "left" }] },
        { cells: [{ binding: "btbdmsTpCdTzNm", align: "left" }] },
    ],
};
